import React from "react"
import { PSE_BLOCK_TYPES } from "../../../utils/productionStepExecution"
import PSESection from "./section/PSESection"
import { StyledCardContent, StyledItemSubtitle } from "./section/StyledSections"
import { Stack } from "@mui/material"
import { StyledItemLabel } from "../styledComponents"

const getItems = (productionStepExecution) => [
  {
    label: "Type de machine",
    value: [productionStepExecution.productionStepSnapshot?.machineType?.name],
  },
  {
    label: "Paramétrage",
    value: [productionStepExecution.productionStepSnapshot?.machineSetting],
  },
  {
    label: "Machine(s)",
    value: (productionStepExecution.machinesBatch || []).map(machine => machine.machineName),
  }
]

const PSEPreparation = ({ productionStepExecution, isEnd, subtitle }) => {
  const displayMachineInformations = !!(productionStepExecution.productionStepSnapshot?.machineTypeName || (productionStepExecution.machinesBatch || []).length || productionStepExecution.productionStepSnapshot?.machineSetting) && !isEnd && !((productionStepExecution.machinesBatch || []).length === 1 && (productionStepExecution.machinesBatch || [])[0].machineName === "Sans Machine")
  const fishParasiteCheckDone = productionStepExecution.events?.some(event => event.change === "withoutFishParasite" && event.value === true)

  return (
    <PSESection
      productionStepExecution={productionStepExecution}
      sectionType={PSE_BLOCK_TYPES.PREPARATION}
      title="Préparation"
      description={productionStepExecution.productionStepSnapshot?.description}
      subtitle={subtitle}
      fishParasiteCheckDone={fishParasiteCheckDone}
    >
      {/* {displayMachineInformations && <PSESectionItemsList items={getItems(productionStepExecution)} />} */}
      {displayMachineInformations && (
        <Stack spacing={2}>
          <StyledCardContent direction="row" spacing={3}>
            {getItems(productionStepExecution).map((item, index) => (
              <Stack key={item.value + index} spacing={1}>
                <StyledItemLabel>
                  {item.label}
                </StyledItemLabel>
                {item.value.length > 0 && item.value.map((optionLabel, itemIndex) => (
                  <StyledItemSubtitle key={optionLabel + itemIndex}>
                    {optionLabel}
                  </StyledItemSubtitle>
                ))}
              </Stack>
            ))}
          </StyledCardContent>
        </Stack>
      )}
    </PSESection>
  )
}

export default PSEPreparation